import { render, staticRenderFns } from "./documentation_page.vue?vue&type=template&id=6365b0a7&scoped=true&"
import script from "./documentation_page.vue?vue&type=script&lang=js&"
export * from "./documentation_page.vue?vue&type=script&lang=js&"
import style0 from "./documentation_page.vue?vue&type=style&index=0&id=6365b0a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365b0a7",
  null
  
)

export default component.exports